class IraEverydaySections {
  constructor() {
    document.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('pointerover', this.onMegaLink.bind(this));
    document.addEventListener('focusin', this.onMegaLink.bind(this));
    document.addEventListener('shopify:section:load', this.refresh.bind(this));
    this.refresh();
  }

  refresh() {
    this.playVideos();
    this.initCarousels();
  }

  onClick(event) {
    const scrollButton = event.target.closest('[data-ira-scroll]');
    if (scrollButton) {
      const section = scrollButton.closest('[data-ira-section]');
      const rail = section?.querySelector('[data-ira-rail]');
      const direction = Number(scrollButton.dataset.iraScroll || 1);
      rail?.scrollBy({ left: direction * Math.min(rail.clientWidth * 0.85, 520), behavior: 'smooth' });
      return;
    }

    const flipButton = event.target.closest('[data-ira-flip]');
    if (flipButton) {
      const card = flipButton.closest('.ira-tone-card');
      const nextState = !card?.classList.contains('is-flipped');
      card?.classList.toggle('is-flipped', nextState);
      flipButton.setAttribute('aria-expanded', String(nextState));
      return;
    }

    const submenuButton = event.target.closest('[data-ira-submenu-toggle]');
    if (submenuButton) {
      const item = submenuButton.closest('.ira-site-header__nav-item');
      const nextState = !item?.classList.contains('is-open');
      document.querySelectorAll('.ira-site-header__nav-item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-ira-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      item?.classList.toggle('is-open', nextState);
      submenuButton.setAttribute('aria-expanded', String(nextState));
      return;
    }

    const menuClose = event.target.closest('[data-ira-menu-close]');
    if (menuClose) {
      menuClose.closest('[data-ira-mobile-menu]')?.removeAttribute('open');
      return;
    }

    const carouselControl = event.target.closest('[data-ira-carousel-prev], [data-ira-carousel-next], [data-ira-carousel-dot]');
    if (carouselControl) {
      const carousel = carouselControl.closest('[data-ira-carousel]');
      const total = carousel?.querySelectorAll('[data-ira-slide]').length || 0;
      if (!total) return;
      const current = Number(carousel.dataset.activeIndex || 0);
      let next = carouselControl.hasAttribute('data-ira-carousel-prev') ? current - 1 : current + 1;
      if (carouselControl.hasAttribute('data-ira-carousel-dot')) next = Number(carouselControl.dataset.index || 0);
      this.setCarouselSlide(carousel, (next + total) % total, true);
      return;
    }

    const pincodeButton = event.target.closest('[data-ira-pincode-submit]');
    if (pincodeButton) {
      this.estimateDelivery(pincodeButton.closest('[data-ira-pincode]'));
      return;
    }

    const shareButton = event.target.closest('[data-ira-share]');
    if (shareButton) {
      this.shareProduct(shareButton);
    }
  }

  onKeydown(event) {
    if (event.key === 'Enter' && event.target.matches('[data-ira-pincode-input]')) {
      event.preventDefault();
      this.estimateDelivery(event.target.closest('[data-ira-pincode]'));
      return;
    }

    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ira-tone-card.is-flipped').forEach((card) => {
      card.classList.remove('is-flipped');
      card.querySelector('[data-ira-flip]')?.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.ira-site-header__nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-ira-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-ira-mobile-menu][open]').forEach((menu) => menu.removeAttribute('open'));
  }

  onMegaLink(event) {
    const link = event.target.closest('[data-ira-mega-link]');
    const imageUrl = link?.dataset.image;
    const image = link?.closest('.ira-mega-menu')?.querySelector('.ira-mega-menu__visual img');
    if (image && imageUrl && image.src !== imageUrl) image.src = imageUrl;
  }

  initCarousels() {
    document.querySelectorAll('[data-ira-carousel]').forEach((carousel) => {
      if (carousel.dataset.iraInitialized === 'true') return;
      carousel.dataset.iraInitialized = 'true';
      carousel.dataset.activeIndex = '0';
      const restart = () => this.startCarousel(carousel);
      carousel.addEventListener('pointerenter', () => this.stopCarousel(carousel));
      carousel.addEventListener('pointerleave', restart);
      carousel.addEventListener('focusin', () => this.stopCarousel(carousel));
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) restart();
      });
      this.startCarousel(carousel);
    });
  }

  setCarouselSlide(carousel, index, announce = false) {
    const slides = [...carousel.querySelectorAll('[data-ira-slide]')];
    const dots = [...carousel.querySelectorAll('[data-ira-carousel-dot]')];
    if (!slides.length) return;
    carousel.dataset.activeIndex = String(index);
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === index)));
    if (announce) {
      const status = carousel.querySelector('[data-ira-carousel-status]');
      if (status) status.textContent = `Slide ${index + 1} of ${slides.length}`;
    }
    this.startCarousel(carousel);
  }

  startCarousel(carousel) {
    this.stopCarousel(carousel);
    if (carousel.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = Math.max(Number(carousel.dataset.interval || 6000), 5000);
    carousel.iraTimer = window.setInterval(() => {
      const total = carousel.querySelectorAll('[data-ira-slide]').length;
      const current = Number(carousel.dataset.activeIndex || 0);
      this.setCarouselSlide(carousel, (current + 1) % total);
    }, interval);
  }

  stopCarousel(carousel) {
    if (carousel.iraTimer) window.clearInterval(carousel.iraTimer);
    carousel.iraTimer = null;
  }

  estimateDelivery(wrapper) {
    const input = wrapper?.querySelector('[data-ira-pincode-input]');
    const status = wrapper?.querySelector('[data-ira-pincode-status]');
    const pincode = input?.value.trim() || '';
    if (!/^\d{6}$/.test(pincode)) {
      if (status) status.textContent = 'Enter a valid 6-digit pincode.';
      input?.focus();
      return;
    }
    const sameDay = (wrapper.dataset.sameDayPincodes || '').split(',').map((value) => value.trim()).includes(pincode);
    if (sameDay) {
      if (status) status.textContent = 'Same-day delivery is available for this pincode when ordered before the local cut-off.';
      return;
    }
    const minDays = Number(wrapper.dataset.standardMin || 3);
    const maxDays = Number(wrapper.dataset.standardMax || 7);
    const minDate = new Date();
    const maxDate = new Date();
    minDate.setDate(minDate.getDate() + minDays);
    maxDate.setDate(maxDate.getDate() + maxDays);
    const format = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' });
    if (status) status.textContent = `Estimated delivery: ${format.format(minDate)}–${format.format(maxDate)}. Final timing is confirmed at checkout.`;
  }

  async shareProduct(button) {
    const status = button.parentElement?.querySelector('[data-ira-share-status]');
    try {
      if (navigator.share) {
        await navigator.share({ title: document.title, url: window.location.href });
        if (status) status.textContent = 'Share sheet opened.';
      } else {
        await navigator.clipboard.writeText(window.location.href);
        if (status) status.textContent = 'Product link copied.';
      }
    } catch (error) {
      if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the page address from your browser to share this product.';
    }
  }

  playVideos() {
    document.querySelectorAll('[data-ira-autoplay]').forEach((video) => {
      video.muted = true;
      video.play?.().catch(() => {});
    });
  }
}

if (!window.iraEverydaySections) window.iraEverydaySections = new IraEverydaySections();
